import React from 'react'
import {
  FormDashboardLabel as Label,
  FormRow,
  SaveButton,
  VisibilityCheckboxes as Checkboxes,
} from '../../../components'

const ContentVisibility = () => {
  return (
    <div className="py-8 lg:py-0 w-full">
      <FormRow>
        <div className="mb-5 lg:mb-10">
          <Label>Field A</Label>
          <div className="pt-3">
            <Checkboxes name="field_a"/>
          </div>
        </div>
      </FormRow>
      <FormRow>
        <div className="mb-5 lg:mb-10">
          <Label>Field B</Label>
          <div className="pt-3">
            <Checkboxes name="field_b"/>
          </div>
        </div>
      </FormRow>
      <FormRow>
        <div className="mb-5 lg:mb-10">
          <Label>Field C</Label>
          <div className="pt-3">
            <Checkboxes name="field_c"/>
          </div>
        </div>
      </FormRow>
      <FormRow>
        <div className="mb-5 lg:mb-10">
          <Label>Field D</Label>
          <div className="pt-3">
            <Checkboxes name="field_d"/>
          </div>
        </div>
      </FormRow>
      <SaveButton />
    </div>
  )
}

export { ContentVisibility }